import { apiService } from './api';
import { Media } from '../types/media';
import { AxiosResponse } from 'axios';

const MEDIA_BASE_PATH = '/Media';

export const mediaService = {
    uploadFile: async (file: File, taskDraftId?: string, taskEntityId?: string): Promise<Media> => {
        const formData = new FormData();
        formData.append('file', file);

        if (taskDraftId) {
            formData.append('taskDraftId', taskDraftId);
        }
        if (taskEntityId) {
            formData.append('taskEntityId', taskEntityId);
        }

        const response = await apiService.post<Media>(`${MEDIA_BASE_PATH}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    deleteFile: async (mediaId: string): Promise<AxiosResponse<void>> => {
        return apiService.delete<void>(`${MEDIA_BASE_PATH}/${mediaId}`);
    },
};
